(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/game-package/assets/react/components/game-card/campaign-info.js') >= 0) return;  svs.modules.push('/modules/game-package/assets/react/components/game-card/campaign-info.js');

'use strict';

const {
  date
} = svs.utils;
const {
  productMapping
} = svs.numbergames;
const CampaignInfo = _ref => {
  let {
    campaignInfo,
    productItsId
  } = _ref;
  if (!campaignInfo || !campaignInfo.numberOfChances) {
    return null;
  }
  const {
    name,
    startDate,
    endDate,
    numberOfChances,
    drawDate
  } = campaignInfo;
  return React.createElement("div", null, React.createElement("span", null, productMapping.getProductName(productItsId), " kampanj"), " ", React.createElement("span", {
    className: "f-medium"
  }, name), React.createElement("br", null), "Kampanjperiod: ", date.ShortDateAndTime(startDate, true, false), "-", date.ShortDateAndTime(endDate, true, false), React.createElement("br", null), "Dragning: ", date.ShortDateAndTime(drawDate, true, false), React.createElement("p", {
    className: "f-medium"
  }, numberOfChances, " ", numberOfChances > 1 ? 'chanser' : 'chans'));
};
svs.gamePackage.components.CampaignInfo = CampaignInfo;

 })(window);